import { useNumericMenu, useStats } from 'react-instantsearch';

import InstantSearchAccordion from './units/instantSearchAccordion';
import InstantSearchFilterOption from './units/instantSearchFilterOption';
import InstantSearchFilterExplanation, {
  InstantSearchFilterExplanationProps,
} from './units/instantSearchFilterExplanation';

import type { FilterProps } from '@javascript/types/InstantSearch';
import useCurrentSortOrder from '../hooks/useCurrentSortOrder';

interface SingleSelectNumericFilterItem {
  label: string;
  end?: number;
  start?: number;
}
export interface SingleSelectNumericFilterProps
  extends FilterProps,
    Partial<InstantSearchFilterExplanationProps> {
  itemList: SingleSelectNumericFilterItem[];
}

const SingleSelectNumericFilter = ({
  attribute,
  explanation,
  label,
  itemList,
  labelSuffix,
  filtersOpen,
}: SingleSelectNumericFilterProps) => {
  const { nbHits } = useStats();
  const index = useCurrentSortOrder();

  const { items, refine, sendEvent } = useNumericMenu({
    attribute: attribute,
    items: itemList,
  });

  const selectedItem = items.find((item) => item.isRefined);

  const noSelection = selectedItem && selectedItem.label === 'Any';

  if (nbHits === 0 && !selectedItem) return null;

  const selectedOption = noSelection || !selectedItem ? '' : selectedItem.label;

  return (
    <InstantSearchAccordion
      filtersOpen={filtersOpen}
      label={label}
      labelSuffix={labelSuffix}
      selectedOptions={selectedOption === '£0' ? 'Free' : selectedOption}
    >
      <ul>
        {items.map((item) => (
          <InstantSearchFilterOption.Radio
            attribute={attribute}
            isSelected={item.isRefined}
            key={item.label}
            label={item.label}
            onChange={() => {
              refine(item.value);
              sendEvent({
                insightsMethod: 'clickedFilters',
                widgetType: 'ais.numeric-menu',
                eventType: 'click',
                payload: {
                  eventName: 'Filter Applied',
                  filters: [`${attribute}:${item.value}`],
                  index,
                },
                attribute,
              });
            }}
          />
        ))}
      </ul>
      {explanation && (
        <InstantSearchFilterExplanation explanation={explanation} />
      )}
    </InstantSearchAccordion>
  );
};
export default SingleSelectNumericFilter;
